import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  const value = Number(price);
  if (!Number.isFinite(value)) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatNumber(num) {
  return new Intl.NumberFormat('en-US').format(num);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('es-419', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatRelativeTime(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  
  if (diffInSeconds < 60) return 'Ahora mismo';
  if (diffInSeconds < 3600) return `hace ${Math.floor(diffInSeconds / 60)} min`;
  if (diffInSeconds < 86400) return `hace ${Math.floor(diffInSeconds / 3600)} h`;
  if (diffInSeconds < 604800) return `hace ${Math.floor(diffInSeconds / 86400)} d`;
  
  return formatDate(dateString);
}

export function truncateText(text, maxLength = 100) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

export function getConditionBadgeColor(condition) {
  const colors = {
    new: 'bg-green-600',
    used: 'bg-blue-600',
    certified: 'bg-purple-600',
    salvage: 'bg-red-600',
  };
  return colors[condition] || 'bg-gray-600';
}

export function getConditionLabel(condition) {
  const labels = {
    new: 'Nuevo',
    used: 'Usado',
    certified: 'Certificado',
    salvage: 'Para reparar',
  };
  return labels[condition] || condition;
}

export function getErrorMessage(error, fallback = 'Algo salió mal') {
  const detail = error?.response?.data?.detail;
  if (!detail) return error?.message || fallback;
  if (typeof detail === 'string') return detail;
  // Pydantic v2 returns an array of {type, loc, msg, input, url}
  if (Array.isArray(detail)) {
    return (
      detail
        .map((e) => {
          if (typeof e === 'string') return e;
          const field = Array.isArray(e?.loc) ? e.loc.slice(-1)[0] : '';
          const msg = e?.msg || '';
          return field ? `${field}: ${msg}` : msg;
        })
        .filter(Boolean)
        .join(' · ') || fallback
    );
  }
  if (typeof detail === 'object') return detail.msg || JSON.stringify(detail);
  return String(detail);
}


export function getRoleLabel(role) {
  const labels = {
    buyer: 'Comprador',
    seller: 'Vendedor',
    dealer: 'Concesionario',
    admin: 'Administrador',
  };
  return labels[role] || role;
}

export function getCategoryLabel(categoryId, categories = []) {
  if (!categoryId) return '';
  const found = categories.find((c) => c.id === categoryId);
  if (found) return found.name;
  // Fallback static map (matches database.DEFAULT_CATEGORIES)
  const fallback = {
    trucks: 'Camiones',
    trailers: 'Remolques',
    camionetas: 'Camionetas',
    cars: 'Autos',
    motorcycles: 'Motos',
    boats: 'Embarcaciones',
    parts: 'Repuestos',
    engines: 'Motores',
    equipment: 'Maquinaria',
  };
  return fallback[categoryId] || categoryId;
}

export function getStatusLabel(status) {
  const labels = {
    draft: 'Borrador',
    active: 'Activo',
    sold: 'Vendido',
    archived: 'Archivado',
  };
  return labels[status] || status;
}

export function getStatusBadgeColor(status) {
  const colors = {
    draft: 'bg-gray-500',
    active: 'bg-green-500',
    sold: 'bg-blue-500',
    archived: 'bg-gray-400',
  };
  return colors[status] || 'bg-gray-500';
}

export function getCategoryIcon(categoryId) {
  const icons = {
    trucks: 'Truck',
    trailers: 'Container',
    camionetas: 'Car',
    cars: 'Car',
    motorcycles: 'Bike',
    boats: 'Ship',
    parts: 'Wrench',
    engines: 'Cog',
    equipment: 'HardHat',
  };
  return icons[categoryId] || 'Package';
}
